// extracted by mini-css-extract-plugin
export var button = "transition-team-slider-module--button--OGxvL";
export var container = "transition-team-slider-module--container--umkXn";
export var next = "transition-team-slider-module--next--2C8Tm";
export var prev = "transition-team-slider-module--prev--lzX75";
export var slider = "transition-team-slider-module--slider--579A+";
export var sliderGrid = "transition-team-slider-module--slider-grid--KYPzj";
export var title = "transition-team-slider-module--title--86Qma";